import React from "react";
import { ChevronDown, Settings2 } from "lucide-react";
import { Button, Popover, PopoverContent, PopoverTrigger, Separator } from "randmarcomps";
import DocumentActions from "./actions/DocumentActions";

interface DocumentActionsMenuProps {
  documentNumber: string;
  documentName: string;
}

const DocumentActionsMenu: React.FC<DocumentActionsMenuProps> = ({ documentNumber, documentName }) => {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          className="h-10 gap-2 rounded-xl"
          aria-label={`Open actions for ${documentName} ${documentNumber}`}
        >
          <Settings2 className="h-4 w-4" aria-hidden="true" />
          Actions
          <ChevronDown className="h-4 w-4" aria-hidden="true" />
        </Button>
      </PopoverTrigger>

      <PopoverContent side="bottom" align="end" className="w-[320px] rounded-2xl border border-gray-100 bg-white p-3 shadow-sm">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">Document actions</p>
            <p className="text-sm font-semibold text-slate-900">{documentName}</p>
          </div>
          <span className="text-xs font-mono text-slate-500">{documentNumber}</span>
        </div>
        <Separator className="my-3" />
        <DocumentActions documentNumber={documentNumber} />
      </PopoverContent>
    </Popover>
  );
};

export default DocumentActionsMenu;
